export function replaceViewContainer(newContainer) {
    let vc = document.getElementById('view-container');
    replaceContent(vc, newContainer);
}

export function replaceContent(container, content) {
    container.innerHTML = '';
    container.appendChild(content);
}

export function renderTemplate(id) {
    return document.getElementById(id).content.cloneNode(true).firstElementChild;
}
